<template>
    <modal :show.sync=show modalClasses="medium-sized-modal modal-hide-footer" headerClasses="pb-0">
        <h3 slot="header" class="mb-0 font-weight-500">Edit Team Name</h3>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form">
                <b-row>
                    <b-col cols="12">
                        <b-form-group>
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ required: true }"
                                :vid="'hubType'"
                            >
                                <b-form-input
                                v-model="form.hub_team_name"
                                placeholder="Enter Hub Name"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="mx-auto text-center pt-2">
                        <b-button type="submit" class="w-100" variant="primary" @click.prevent="updateTeamDetails()" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader
} from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useHubStore } from '@/stores/hubStore'

export default {
    props:{
        show_edit_team: Boolean
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
    },
    computed: {
        show: {
            get() {
                return this.show_edit_team;
            },
            set(newVal) {
                this.$emit('update:show_edit_team', newVal);
            },
        },

        ...mapState(useHubStore,['current_team'])
    },
    data() {
        return {
            form: {
                hub_id: '',
                user_id: '',
                hub_team_name: '',
            },
        }
    },
    async created() {
        this.$watch(
            () => this.current_team,
            (newVal) => {
                if (newVal) {
                    this.form.hub_id = newVal.hub.hub_id ?? ''; 
                    this.form.user_id = newVal.hub.hub_manager.id ?? '';
                    this.form.hub_team_name = newVal.hub_team_name ?? '';
                }
            },
            { immediate: true }
        )
    },
    methods: {
        ...mapActions(useHubStore,['getHubTeams']),
        updateTeamDetails() {
            const postData = {
                hub_id: this.form.hub_id,
                user_id: this.form.user_id,
                hub_team_name: this.form.hub_team_name,
            }

            axios.put(services.hub + 'hub_team/' + this.current_team.hub_team_id, postData ,{ headers: getHeader() })
            .then ( response => {
                if (response.status === 200)
                {
                    this.$notify({
                    message:
                        '<b>Hub : ' + response.data.data.hub_team_name + '</b> - Successfully Updated.',
                    timeout: 10000,
                    icon: 'ni ni-bell-55',
                    type: 'default',
                    });
                    this.getHubTeams(this.current_team.hub_team_id)
                }
            })
            .catch ( error => {
                this.errorFunction(error, "Edit Team")
            });
        }
    }
}
</script>